(() => {
 const instances = new Map(), reduced = matchMedia('(prefers-reduced-motion: reduce)');
 function init(root) {
  instances.get(root)?.();
  let measuredWidth=innerWidth,headerHeight=0,announcementHeight=0,lastLift=-1;
  let frame=0,start=0,travel=0,lastY=scrollY,navVisible=true,navDirection=0,navTravel=0,wrap=null,spacer=null,support=null;
  const main=document.getElementById('MainContent');
  const header=root.dataset.navOverlay==='true'?document.querySelector('.shopify-section-main-header'):null;
  const announcement=document.querySelector('.announcement-bar-section');
  const guide=document.querySelector('.lenotos-blind-guide');
  const guideLink=root.querySelector('[data-lr-guide]');
  const guideTarget=guide?.closest('.shopify-section')||guide;
  if(guideTarget&&guideLink){if(!guideTarget.id)guideTarget.id='lenotos-blind-guide';guideLink.href='#'+guideTarget.id;}
  if(header&&root.dataset.contactIcon==='true'&&!header.querySelector('.lr-support-link')){
   support=document.createElement('a');support.className='lr-support-link';support.href=root.dataset.contactLink||'/pages/contact';support.setAttribute('aria-label','Contact us');support.title='Contact us';
   support.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 3 3 4-2 2c1 3 3 5 6 6l2-2 4 3-1 4C9 21 3 15 3 7Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';
   const icons=header.querySelector('.header__icons'),search=icons?.querySelector('.header-search-icon');if(search)search.after(support);else icons?.prepend(support);
  }
  function unpin(){
   if(wrap&&main){wrap.parentNode.insertBefore(main,wrap);wrap.remove();}
   wrap=null;spacer=null;root.classList.remove('lr-pinned');
  }
  function measure(){
   headerHeight=header?.offsetHeight||0;announcementHeight=announcement?.offsetHeight||0;
   const enabled=root.dataset.enabled==='true'&&!reduced.matches;
   if(enabled&&main&&!wrap){
    wrap=document.createElement('div');wrap.className='lr-pin-wrap';main.parentNode.insertBefore(wrap,main);wrap.appendChild(main);
    spacer=document.createElement('div');spacer.className='lr-pin-spacer';spacer.setAttribute('aria-hidden','true');wrap.appendChild(spacer);root.classList.add('lr-pinned');
   }else if(!enabled)unpin();
   start=(wrap||root).getBoundingClientRect().top+scrollY;
   root.style.setProperty('--lr-start-offset',Math.max(0,start)+'px');
   travel=enabled?(root.querySelector('.lr-cover')?.offsetHeight||0):0;
   wrap?.style.setProperty('--lr-travel',travel+'px');
   update();
  }
  function update(){
   frame=0;
   const y=scrollY,delta=y-lastY,progress=travel?Math.max(0,Math.min(1,(y-start)/travel)):1,complete=progress>=.999;
   const heroRect=header?root.getBoundingClientRect():null;
   const lift=Math.min(travel,Math.max(0,y-start));
   if(lift!==lastLift){
    root.style.setProperty('--lr-progress',complete?'1':progress.toFixed(4));
    root.style.setProperty('--lr-lift',lift+'px');
    root.classList.toggle('lr-lifting',progress>0);root.classList.toggle('lr-halfway',progress>.5);root.classList.toggle('lr-opened',complete);
    lastLift=lift;
   }
   if(header){
    const menuActive=header.querySelector('.navbar-nav > .nav-item:hover,.navbar-nav > .nav-item:focus-within,.navbar-nav details[open]');
    const h=headerHeight,initialTop=announcementHeight;
    let top;
    if(innerWidth<1200 ? y<=initialTop : y<start+travel||y<=initialTop){top=innerWidth<1200?initialTop:Math.max(-h,initialTop-y);navVisible=top>-h;navDirection=0;navTravel=0;}
    else {
     if(innerWidth<1200){
      const direction=Math.sign(delta);
      if(direction&&Math.abs(delta)>=.5){
       if(direction!==navDirection){navDirection=direction;navTravel=0;}
       navTravel+=Math.abs(delta);
       if(direction<0&&navTravel>=24)navVisible=true;
       else if(direction>0&&navTravel>=48)navVisible=false;
      }
     }else{if(delta < -2)navVisible=true;else if(delta>2)navVisible=false;}
     if(menuActive||document.body.classList.contains('nav-open')){navVisible=true;navTravel=0;}
     top=navVisible?0:-h;
    }
    if(innerWidth<1200&&announcement){
     document.body.style.setProperty('--lr-announcement-height',initialTop+'px');
     if(navVisible&&y>initialTop)top=initialTop;
    }
    document.body.style.setProperty('--lr-nav-top',top+'px');

    const overPhoto=heroRect.bottom>h&&heroRect.top<innerHeight;
    header.classList.toggle('lr-header-over',overPhoto&&!menuActive);
   }
   const under=root.querySelector('.lr-under'),hidden=travel>0&&!complete;
   under.inert=hidden;under.setAttribute('aria-hidden',String(hidden));lastY=y;
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(update);}
  function open(){scrollTo({top:Math.ceil(start+travel),behavior:reduced.matches?'instant':'smooth'});}
  function toGuide(e){
   if(!guideTarget)return;e.preventDefault();
   const relative=guideTarget.getBoundingClientRect().top-main.getBoundingClientRect().top;
   const top=wrap?start+travel+relative-90:guideTarget.getBoundingClientRect().top+scrollY-90;
   history.pushState(null,'','#'+guideTarget.id);scrollTo({top:Math.max(0,Math.ceil(top)),behavior:reduced.matches?'instant':'smooth'});
  }
  const button=root.querySelector('.lr-open');button?.addEventListener('click',open);guideLink?.addEventListener('click',toGuide);
  function resize(){if(innerWidth!==measuredWidth||innerWidth>=1200){measuredWidth=innerWidth;measure();}else schedule();}
  addEventListener('scroll',schedule,{passive:true});addEventListener('resize',resize);reduced.addEventListener('change',measure);
  for(const event of ['pointerover','pointerleave','focusin','focusout'])header?.addEventListener(event,schedule);
  const observer=new ResizeObserver(measure);observer.observe(root);if(announcement)observer.observe(announcement);
  measure();
  instances.set(root,()=>{cancelAnimationFrame(frame);removeEventListener('scroll',schedule);removeEventListener('resize',resize);reduced.removeEventListener('change',measure);button?.removeEventListener('click',open);guideLink?.removeEventListener('click',toGuide);for(const event of ['pointerover','pointerleave','focusin','focusout'])header?.removeEventListener(event,schedule);observer.disconnect();support?.remove();header?.classList.remove('lr-header-over');document.body.style.removeProperty('--lr-nav-top');unpin();instances.delete(root);});
 }
 function scan(scope=document){scope.querySelectorAll('[data-lenotos-reveal]').forEach(init);}
 scan();
 document.addEventListener('shopify:section:load',e=>scan(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-lenotos-reveal]').forEach(root=>instances.get(root)?.()));
 document.addEventListener('shopify:section:select',e=>{const root=e.target.querySelector('[data-lenotos-reveal]');if(root){const wrap=root.closest('.lr-pin-wrap');scrollTo({top:(wrap||root).getBoundingClientRect().top+scrollY,behavior:'instant'});}});
})();